var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".arrow-a{fill:#9b2585;}")),React.createElement("path",{"className":"arrow-a","d":"M9.746,3.2a2,2,0,0,1,3.508,0l8.125,14.836A2,2,0,0,1,19.625,21H3.375a2,2,0,0,1-1.754-2.961Z","transform":"translate(21) rotate(90)","key":1})]);
}

Arrow.defaultProps = {"width":"21","height":"23","viewBox":"0 0 21 23"};

module.exports = Arrow;

Arrow.default = Arrow;
